import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["source", "destination"]
  static values = { dirty: { type: Boolean, default: false } }

  sourceChanged() {
    if (this.dirtyValue || !this.hasDestinationTarget) return

    this.destinationTarget.value = this.sourceTarget.value
  }

  destinationChanged() {
    this.dirtyValue = true
  }
}
